module.exports = __webpack_public_path__ + "static/media/logo.dced8047.png";